export default __webpack_public_path__ + "static/media/Bracers of the Putrescent.f299a681.jpg";